// extracted by mini-css-extract-plugin
module.exports = {"one-column":"FiltersCategory_one-column__3A-rh","two-columns":"FiltersCategory_two-columns__3Nm3g"};